import * as React from "react";

import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { CheckboxChangeEvent } from "antd/es/checkbox";

import { MultiCheckboxInput } from "components/form/legacyFields/multiCheckboxInput";

interface ReadOnlyProps {
    values: boolean[];
    onChange?: (checked: boolean) => void;
}

interface EditProps extends ReadOnlyProps {
    onChange: (checked: boolean) => void;
}

type MultiFinancialYearCheckboxProps =
    | ({ type: "READ_ONLY" } & ReadOnlyProps)
    | ({ type: "EDIT" } & EditProps);

class MultiFinancialYearCheckbox extends React.Component<MultiFinancialYearCheckboxProps> {
    render = (): React.ReactNode => {
        const { type } = this.props;

        switch (type) {
            case "EDIT": {
                const { values } = this.props;

                return (
                    <MultiCheckboxInput
                        type="EDIT"
                        id="financialYearId"
                        label={t("CreateControl_Recurrence_UseFinancialYear")}
                        values={values}
                        value={values}
                        onChange={this.onChange}
                        onCheckAllChange={this.onCheckAllChange}
                    />
                );
            }
            case "READ_ONLY": {
                const { values } = this.props;
                return (
                    <MultiCheckboxInput
                        type="READ_ONLY"
                        label={t("CreateControl_Recurrence_UseFinancialYear")}
                        values={values}
                    />
                );
            }
            default: {
                return assertNever(type);
            }
        }
    };

    onCheckAllChange = (e: CheckboxChangeEvent) => {
        if (this.props.onChange) {
            this.props.onChange(e.target.checked);
        }
    };

    onChange = () => {};
}

export { type MultiFinancialYearCheckboxProps, MultiFinancialYearCheckbox };
